import DownloadAppPartial from './DownloadAppPartial';

export default DownloadAppPartial;
